import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const points = ['Betrouwbare bevoorrading voor professionals en particulieren', 'Een gevarieerd assortiment dat voortdurend wordt vernieuwd', 'Persoonlijk advies en een service die naar u luistert'];
export function About() {
  return <section id="a-propos" className="w-full bg-slate-50 py-20" data-id="element-1" data-mp="2ysy8s5d3zksz">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8" data-id="element-2" data-mp="33rro83byhlvs">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} data-id="element-3" data-mp="33pf69q677biq">
          <span className="text-sm font-semibold uppercase tracking-widest text-ardis-red" data-id="element-4" data-mp="3mislmmxfh9d8">
            Over ons
          </span>
          <h2 className="mt-3 font-display text-3xl font-extrabold text-ardis-green sm:text-4xl" data-id="element-5" data-mp="3rh3vuyrmxlvz">
            Uw betrouwbare partner
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate-600" data-id="element-6" data-mp="2grmhzrnazpo4">
            A.D. INTER ondersteunt klanten dagelijks bij hun bevoorrading. Met
            een ruim assortiment en zorgvuldig gekozen prijzen maken we inkopen
            in het groot eenvoudig, toegankelijk en voordelig voor iedereen.
          </p>
        </motion.div>

        <ul className="mx-auto mt-8 flex max-w-2xl flex-col gap-3 text-left" data-id="element-7" data-mp="34jt8492fr0f3">
          {points.map((point, i) => <motion.li key={point} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="flex items-start gap-3 rounded-xl bg-white p-4 shadow-sm ring-1 ring-slate-200" data-id="element-8" data-mp="2vpewqhl10a19" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-ardis-green text-white" data-id="element-9" data-mp="b3vht5kdujti">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-10" data-mp="3tinzyj12aqo2" />
              </span>
              <span className="text-slate-700" data-id="element-11" data-mp="1dkf1mcfqgo7">{point}</span>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}